import {h, Fragment} from "preact"
import { useSort, useProductFilters } from '@nosto/preact'
import { sortOptions } from '../config'
import { useState, useEffect, useRef } from 'preact/hooks'

export default function Filters() {
    const { filters, removeAll } = useProductFilters()
    const { activeSort, setSort } = useSort(sortOptions)
    const [isSortPopoverOpen, setIsSortPopoverOpen] = useState(false)
    const popoverRef = useRef(null)

    const filterCount = filters.length
    const options = sortOptions.map((o) => ({ value: o.id, label: o.value.name }))

    const toggleSortPopover = (event) => {
        event.preventDefault()
        event.stopPropagation()
        setIsSortPopoverOpen((prev) => !prev)
    }

    const handleClickOutside = (event) => {
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setIsSortPopoverOpen(false)
        }
    }

    const closeSortPopover = () => {
        setIsSortPopoverOpen(false)
    }

    const toggleFilterDrawer = () => {
        const drawer = document.getElementById('nosto-facets-drawer')
        if (drawer) {
            drawer.classList.toggle('open')
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutside)

        // Handle clicks on the overlay and close button inside the shadow DOM
        const popoverElement = popoverRef.current?.querySelector('facets-sort-popover')
        if (popoverElement?.shadowRoot) {
            const overlay = popoverElement.shadowRoot.querySelector('[part="overlay"]')
            const closeButton = popoverElement.shadowRoot.querySelector('button')

            if (overlay) {
                overlay.addEventListener('click', closeSortPopover)
            }

            if (closeButton) {
                closeButton.addEventListener('click', closeSortPopover)
            }
        }

        return () => {
            document.removeEventListener('click', handleClickOutside)

            // Cleanup overlay and close button click listeners
            if (popoverElement?.shadowRoot) {
                const overlay = popoverElement.shadowRoot.querySelector('[part="overlay"]')
                const closeButton = popoverElement.shadowRoot.querySelector('[part="close-button"]')

                if (overlay) {
                    overlay.removeEventListener('click', closeSortPopover)
                }

                if (closeButton) {
                    closeButton.removeEventListener('click', closeSortPopover)
                }
            }
        }
    }, [])

    return (
        <div class="collection-toolbar__button-list">
            <div class="collection-toolbar__button-container">
                <button
                    type="button"
                    aria-controls="nosto-facets-drawer"
                    class="collection-toolbar__button heading text-xxs w-full"
                    aria-expanded="false"
                    onClick={toggleFilterDrawer}>
                    Filter {filterCount > 0 && `(${filterCount})`}
                </button>
            </div>
            <div class="collection-toolbar__button-container" ref={popoverRef}>
                <button
                    type="button"
                    aria-controls="nosto-sort-by-popover"
                    class="collection-toolbar__button heading text-xxs w-full"
                    aria-haspopup="dialog"
                    aria-expanded={isSortPopoverOpen}
                    onClick={toggleSortPopover}>
                    <span class="text-with-icon justify-center">
                        Sort by
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            fill="none"
                            width="10"
                            class="icon icon-chevron-down"
                            viewBox="0 0 10 10">
                            <path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path>
                        </svg>
                    </span>
                </button>
                <facets-sort-popover
                    id="nosto-sort-by-popover"
                    section-id="template--24956694004061__main"
                    class={`popover popover--bottom-end color-scheme color-scheme--dialog ${
                        isSortPopoverOpen ? 'open' : ''
                    }`}
                    close-on-listbox-select=""
                    role="dialog"
                    style={{
                        display: isSortPopoverOpen ? 'block' : 'none',
                        opacity: isSortPopoverOpen ? 1 : 0,
                    }}>
                    <p class="h4" slot="header">
                        Sort by
                    </p>
                    <x-listbox class="popover__value-list" role="listbox">
                        {options.map((option) => (
                            <button
                                key={option.value}
                                value={option.value}
                                type="button"
                                class="popover__value-option group"
                                role="option"
                                onClick={() => {
                                    setSort(option.value)
                                }}>
                                <span class="reversed-link"> {option.label}</span>
                            </button>
                        ))}
                    </x-listbox>
                </facets-sort-popover>
            </div>
        </div>
    )
}
